export const REGEXP_VALID_EMAIL = /^[^\s@]+@[^\s@]+$/
export const REGEXP_VALID_URL =
  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
